import React, { useEffect, useState, useRef, FC } from 'react';
import * as eCharts from 'echarts';
import gold from '../../../../../assets/svg/medal/gold.svg';
import silver from '../../../../../assets/svg/medal/silver.svg';
import bronze from '../../../../../assets/svg/medal/bronze.svg';
import blue from '../../../../../assets/svg/medal/blue.svg';

import { useIntl, getLocale } from 'umi';

interface TrendsBarChartProps {
  rankData: any;
}

const pHeatSeriesData = [
  {
    color: '#5086F3',
    value: 20,
  },
  {
    color: '#F19E55',
    value: 30,
  },
  {
    color: '#6E7794',
    value: 40,
  },
  {
    color: '#F8D74D',
    value: 50,
  },
];
const PheatChart: FC<TrendsBarChartProps> = (props) => {
  const { rankData } = props;
  const { numContent } = rankData;
  let myChart: any = null;
  const chartRef = useRef(null);
  const [options, setOptions] = useState<any>();

  const locale = getLocale();
  const getCurrentMedal = (count: number) => {
    if (count <= 0.1) {
      return {
        medal: gold,
        position: 3
      }
    }
    if (count <= 0.2) {
      return {
        medal: silver,
        position: 2
      };
    }
    if (count <= 0.3) {
      return {
        medal: bronze,
        position: 1
      };
    }
    if (count > 0.3) {
      return {
        medal: blue,
        position: 0
      };
    }
    return {
      medal: gold,
      position: 3
    }
  };

  const seriesList = pHeatSeriesData?.map((item, index) => {
    const targetMedal= getCurrentMedal(numContent);
    const { position, medal } = targetMedal || {};
    const pheatValue = (numContent * 100).toFixed(2);
    let markPointConfig =
    position === index
        ? {
            markPoint: {
              data: [
                {
                  xAxis: 0,
                  yAxis: item.value,
                  symbol: `image://${medal}`,
                },
              ],
              symbolSize: 14,
              symbolOffset: [-12, '-185%'],
              label: {
                show: true,
                offset: [20, 0],
                color: '#838697',
                fontSize: 12,
                formatter: () => 'TOP',
              },
            },
          }
        : {};
    return {
      type: 'bar',
      data: [item.value],
      barWidth: 22,
      barGap: '80%',
      itemStyle: {
        normal: {
          color: new eCharts.graphic.LinearGradient(0, 1, 0, 0, [
            {
              offset: 1,
              color: item?.color,
            },
            {
              offset: 0,
              color: '#fff',
            },
          ]),
        },
      },
      label: {
        position: 'top',
        show: position === index,
        color: '#000000',
        fontWeight: 700,
        formatter: () => `${pheatValue}%`,
      },
      ...markPointConfig,
    };
  });

  useEffect(() => {
    const regionOptions = {
      tooltip: {
        show: false,
        backgroundColor: 'rgba(0,0,0,0)'
      },
      legend: {
        show: false,
      },
      grid: {
        // left: 2,
        right: 8,
        bottom: 12,
        top: 30,
        width: 144,
        containLabel: true,
      },
      xAxis: {
        type: 'category',
        data: [1],
        axisTick: {
          show: false,
          alignWithLabel: true,
        },
        axisLabel: {
          show: false,
        },
        axisLine: {
          show: false,
        },
      },
      yAxis: [
        {
          type: 'value',
          splitLine: {
            show: false,
          },
          splitNumber: 3,
          axisLabel: {
            show: false,
          },
        },
      ],
      color: ['#5086F3', '#5EC8F1'],
      series: seriesList,
    };
    setOptions(regionOptions);
  }, [locale, numContent]);

  useEffect(() => {
    if (myChart === null) {
      myChart = eCharts.init(chartRef!.current!);
    }
    options && myChart.setOption(options, true);
  }, [options]);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [myChart]);

  const handleResize = () => {
    try {
      myChart.resize();
    } catch (err) {}
  };
  return (
    <div style={{ height: 108, width: '100%', top: -18 }} ref={chartRef}></div>
  );
};

export default PheatChart;
